import mailboxAxios from "../utils/mailboxAxios";

export async function fetchRoles() {
  const { data } = await mailboxAxios.get("/crm/settings/roles");
  return data.items || [];
}

export async function createRole(payload) {
  const { data } = await mailboxAxios.post("/crm/settings/roles", payload);
  return data;
}

export async function updateRole(id, payload) {
  const { data } = await mailboxAxios.put(`/crm/settings/roles/${id}`, payload);
  return data;
}

export async function fetchPipelineStages() {
  const { data } = await mailboxAxios.get("/crm/settings/pipeline-stages");
  return data.items || [];
}

export async function createPipelineStage(payload) {
  const { data } = await mailboxAxios.post("/crm/settings/pipeline-stages", payload);
  return data;
}

export async function updatePipelineStage(id, payload) {
  const { data } = await mailboxAxios.put(`/crm/settings/pipeline-stages/${id}`, payload);
  return data;
}

export async function fetchChannels() {
  const { data } = await mailboxAxios.get("/crm/settings/channels");
  return data.items || [];
}

export async function createChannel(payload) {
  const { data } = await mailboxAxios.post("/crm/settings/channels", payload);
  return data;
}

export async function updateChannel(id, payload) {
  const { data } = await mailboxAxios.put(`/crm/settings/channels/${id}`, payload);
  return data;
}

export async function fetchLeadStages() {
  const { data } = await mailboxAxios.get("/crm/settings/lead-stages");
  return data.items || [];
}

export async function createLeadStage(payload) {
  const { data } = await mailboxAxios.post("/crm/settings/lead-stages", payload);
  return data;
}

export async function updateLeadStage(id, payload) {
  const { data } = await mailboxAxios.put(`/crm/settings/lead-stages/${id}`, payload);
  return data;
}

export async function fetchActivityTemplates(){
  const { data } = await mailboxAxios.get("/crm/settings/activity-templates");
  return data.items || [];
}

export async function createActivityTemplate(payload){
  const { data } = await mailboxAxios.post("/crm/settings/activity-templates", payload);
  return data;
}

export async function updateActivityTemplate(id,payload){
  const { data } = await mailboxAxios.put(`/crm/settings/activity-templates/${id}`, payload);
  return data;
}

// ---------- CRM Roles ----------
export async function fetchCrmRoles() {
  const { data } = await mailboxAxios.get("/crm/settings/crm-roles");
  return data.items || [];
}

export async function createCrmRole(payload) {
  const { data } = await mailboxAxios.post("/crm/settings/crm-roles", payload);
  return data.item;
}

export async function updateCrmRole(id, payload) {
  const { data } = await mailboxAxios.put(`/crm/settings/crm-roles/${id}`, payload);
  return data;
}

// ---------- CRM User Roles ----------
export async function fetchCrmUserRoles() {
  const { data } = await mailboxAxios.get("/crm/settings/crm-user-roles");
  return data.items || [];
}

export async function createCrmUserRole(payload) {
  const { data } = await mailboxAxios.post("/crm/settings/crm-user-roles", payload);
  return data.item;
}

export async function deleteCrmUserRole(id) {
  const { data } = await mailboxAxios.delete(`/crm/settings/crm-user-roles/${id}`);
  return data;
}

// ---------- CRM Role Mailboxes ----------
export async function fetchCrmRoleMailboxes() {
  const { data } = await mailboxAxios.get("/crm/settings/crm-role-mailboxes");
  return data.items || [];
}

export async function createCrmRoleMailbox(payload) {
  const { data } = await mailboxAxios.post("/crm/settings/crm-role-mailboxes", payload);
  return data.item;
}

export async function updateCrmRoleMailbox(id, payload) {
  const { data } = await mailboxAxios.put(`/crm/settings/crm-role-mailboxes/${id}`, payload);
  return data;
}

export async function deleteCrmRoleMailbox(id) {
  const { data } = await mailboxAxios.delete(`/crm/settings/crm-role-mailboxes/${id}`);
  return data;
}